import "./src/scss/_all.scss";
import "./src/scss/v2/_all.scss";
import { RecoilRoot } from "recoil";
import ComplexElement from "./src/components/ComplexElement";

// Wraps every page in a component
export const wrapPageElement = ({ element, ...props }) => <ComplexElement {...props}>{element}</ComplexElement>;

export const wrapRootElement = ({ element }) => <RecoilRoot>{element}</RecoilRoot>;
